
































































































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { saveAs } from 'file-saver';

import AuthMixin from '../mixins/AuthMixin';
import LayoutModal from '@/components/LayoutModal.vue';
import {
  SET_APIKEY,
  GET_AUTHENTICATED,
  GET_APIKEY,
} from '@/store/modules/auth/types';
import { SET_VIDEO_STORE } from '../store/modules/video/types';

import { tagBuilder } from '@/utils/tagParser';

@Component
export default class ShareModal extends Mixins(AuthMixin) {
  @Prop() readonly unsaved_changes!: number;
  @Prop() readonly linked_id!: string | null;
  @Prop() readonly video!: any;
  @Prop() readonly tracks!: any[];
  @Prop() readonly tags!: any[];
  @Prop() readonly query!: any;
  @Prop() readonly layout!: any;
  @Prop() readonly data!: any;

  unsaved_changes_instance = this.unsaved_changes;
  authorized_instance: boolean = false;
  saving: boolean = false;
  id: string = this.video.id;
  linked_id_instance = this.linked_id;
  authenticated: boolean = this.$store.getters[`auth/${GET_AUTHENTICATED}`];
  api_key: string | null = this.$store.getters[`auth/${GET_APIKEY}`];
  url: any = process.env.VUE_APP_URL;
  layout_instance: any = {
    ...this.layout,
  };

  mounted() {
    this.buildLink();
    console.log(this.video, this.tracks, this.tags, this.data);
  }

  buildTag() {
    let share_query = {
      ...this.query,
      ...this.layout_instance,
    };

    if (this.linked_id_instance && this.api_key) {
      delete share_query.show_controls;
    }

    return tagBuilder(
      this.video,
      this.tracks,
      this.tags,
      share_query,
      this.data
    );
  }

  buildLink() {
    const { path_string, query_string } = this.buildTag();

    if (this.video.type === 'source') {
      this.id = encodeURIComponent(this.video.id);
    }

    if (this.linked_id_instance) {
      this.url = `${process.env.VUE_APP_URL}/video/id/${this.linked_id_instance}${query_string}`;
    } else {
      this.url = `${process.env.VUE_APP_URL}/video/${this.video.type}/${this.id}/${path_string}${query_string}`;
    }
  }

  saveVideoStore(
    type: string,
    id: string | null,
    path_string: string,
    query_object: any
  ) {
    this.$store.dispatch(`video/${SET_VIDEO_STORE}`, {
      type,
      id,
      data: path_string,
      query: query_object,
    });
  }

  openLayoutModal() {
    this.$buefy.modal.open({
      parent: this,
      component: LayoutModal,
      hasModalCard: true,
      canCancel: ['escape', 'outside'],
      props: {
        layout: this.layout_instance,
      },
      events: {
        done: (data: any) => {
          this.layout_instance = data;
          this.buildLink();
        },
      },
    });
  }

  async generateLink(update?: boolean, retry?: boolean) {
    this.saving = true;
    const { path_string, query_string, query_object } = this.buildTag();

    try {
      if (!update) {
        if (!this.$store.getters[`auth/${GET_AUTHENTICATED}`]) {
          const registered = await this.authRegister();
          if (registered && registered.data) {
            this.api_key = registered.data.api_key;
          }
        }

        const response = await this.$http.post('/video', {
          video: {
            type: this.video.type,
            id: decodeURIComponent(this.id),
            name: this.video.name,
          },
          data: decodeURIComponent(path_string),
          params: query_object || {},
        });

        this.linked_id_instance = response.data.id;
        this.authorized_instance = true;

        window.history.pushState(
          {},
          document.title,
          `/video/id/${this.linked_id_instance}${query_string}`
        );

        this.unsaved_changes_instance = 0;
        this.$buefy.toast.open(
          'Short link generated. Keep your secret key safe to update this link.'
        );
      } else {
        const response = await this.$http.put(
          `/video/${this.linked_id_instance}`,
          {
            video: {
              type: this.video.type,
              id: decodeURIComponent(this.id),
              name: this.video.name,
            },
            data: decodeURIComponent(path_string),
            params: query_object || {},
          }
        );

        this.authorized_instance = true;

        window.history.replaceState(
          {},
          document.title,
          `/video/id/${this.linked_id_instance}${query_string}`
        );

        this.unsaved_changes_instance = 0;
        this.$buefy.toast.open('Short link updated.');
      }

      this.saveVideoStore(
        'id',
        this.linked_id_instance,
        decodeURIComponent(path_string),
        query_object
      );

      this.buildLink();
      this.saving = false;
    } catch (e) {
      if (e.response.status === 401) {
        if (!retry) {
          this.generateLink(update, true);
          return;
        }
        this.authInvalidate();
        this.api_key = null;
        this.$buefy.toast.open({
          message: 'The key provided is not valid.',
          type: 'is-warning',
        });
      } else if (e.response.status === 404) {
        this.authInvalidate();
        this.api_key = null;
        this.$buefy.toast.open({
          message: 'Link id not found or invalid key.',
          type: 'is-warning',
        });
      } else if (e.response.status === 422) {
        this.authInvalidate();
        this.api_key = null;
        this.$buefy.toast.open({
          message: 'Invalid video data.',
          type: 'is-warning',
        });
      } else {
        this.$buefy.toast.open({
          message: 'Error creating short link.',
          type: 'is-warning',
        });
      }
      this.saving = false;
    }
  }

  copySuccess() {
    this.$buefy.toast.open('Copied to clipboard.');
  }

  copyError() {
    this.$buefy.toast.open({
      message: 'Failed to copy to clipboard, please copy manually.',
      type: 'is-warning',
    });
  }

  exportJson() {
    console.log(this.video, this.tracks, this.tags, this.data);
    const jsonBlob = new Blob(
      [
        JSON.stringify(
          {
            video: this.video,
            tracks: this.tracks,
            tags: this.tags.map((tag) => {
              return {
                id: tag.id,
                track: tag.track,
                start: tag.start,
                end: tag.end,
                name: tag.name,
              };
            }),
          },
          null,
          2
        ),
      ],
      {
        type: 'application/json;charset=utf-8',
      }
    );
    saveAs(jsonBlob, `tagx-export-${this.video.id}.json`);
  }

  done() {
    this.$emit('done', {
      unsaved_changes: this.unsaved_changes_instance,
      linked_id: this.linked_id_instance,
      authorized: this.authorized_instance,
    });
    this.$emit('close');
  }
}
